
import { BASE_URL_PRODUCCION } from "../../utils/Constants"

export const SubirDataTemporalApi = async (id_persona,id_solicitud) => {
  try{
        const url = `${BASE_URL_PRODUCCION}/datatemporalsapintra`
        debugger
        const params = {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          method: "POST",
          body: JSON.stringify({
            id_persona: id_persona,
            id_solicitud: id_solicitud
          })
        }
        const res = await fetch(url, params);
        const resJSON = await res.json()
        return resJSON;
  } catch (error) {
        console.log("Error: ", error)
        return ""
      }
}